export function TownLinks({ town }) {
  const name    = town.name;
  const encoded = encodeURIComponent(name + " Portugal");

  const links = [
    {
      icon: "🏠",
      label: "Idealista",
      url: `https://www.idealista.pt/comprar-casas/${name.toLowerCase().replace(/\s+/g, "-").replace(/[áàã]/g,"a").replace(/[éê]/g,"e").replace(/[íî]/g,"i").replace(/[óõô]/g,"o").replace(/[úû]/g,"u").replace(/ç/g,"c")}/`,
      hint: "Vastgoed te koop"
    },
    {
      icon: "🏡",
      label: "Casa Sapo",
      url: `https://casa.sapo.pt/comprar/imoveis-em-${encodeURIComponent(name.toLowerCase())}/`,
      hint: "Portugees vastgoedplatform"
    },
    {
      icon: "💬",
      label: "Expat forum",
      url: `https://www.expatforum.com/threads/?q=${encoded}`,
      hint: "Ervaringen van expats"
    },
    {
      icon: "📍",
      label: "Google Maps",
      url: `https://www.google.com/maps/search/${encoded}`,
      hint: "Bekijk op de kaart"
    },
    {
      icon: "📖",
      label: "Wikipedia",
      url: `https://pt.wikipedia.org/wiki/${encodeURIComponent(town.vibe?.wikiPage || name)}`,
      hint: "Achtergrond & geschiedenis"
    },
  ];

  return (
    <div style={{ padding: "12px 0", borderTop: "1px solid #eee", marginTop: 12 }}>
      <div style={{ fontSize: 12, color: "#888", marginBottom: 8, fontWeight: 600 }}>
        SNELLE LINKS
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {links.map(l => (
          <a key={l.label} href={l.url} target="_blank" rel="noopener noreferrer"
             title={l.hint}
             style={{
               display: "inline-flex", alignItems: "center", gap: 5,
               padding: "5px 10px", borderRadius: 20,
               border: "1px solid #ddd", background: "#f8f5f0",
               fontSize: 12, color: "#444", textDecoration: "none",
               transition: "background 0.15s",
             }}
             onMouseOver={e => e.currentTarget.style.background = "#ede8df"}
             onMouseOut={e => e.currentTarget.style.background = "#f8f5f0"}
          >
            <span>{l.icon}</span>
            <span>{l.label}</span>
          </a>
        ))}
      </div>
    </div>
  );
}
